import React, { useEffect } from "react";
import theme from "../../../theme";
import { useDispatch, useSelector } from "react-redux";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { Content, Footer } from "./PieChartStyle";

import { convertToLocalCurrency } from "../../../utils/currency";

import { getAudienceReach } from "../../../redux/slices/overviewSlice";

const COLORS = [theme.chart[1], theme.chart[3], theme.chart[4]];

const PieChartTab = () => {
  const dispatch = useDispatch();
  const { audienceReach } = useSelector((state) => state.overview);

  useEffect(() => {
    dispatch(getAudienceReach());
  }, [dispatch]);

  const data = [
    { name: "Conversion", value: audienceReach.totalConversions },
    { name: "Clicks", value: audienceReach.totalClicks },
    { name: "Amount Spent", value: audienceReach.moneySpent }, //divide by 100 later
  ];

  const originalData = [
    { name: "Conversion", value: audienceReach.totalConversions },
    { name: "Clicks", value: audienceReach.totalClicks },
    { name: "Amount Spent", value: convertToLocalCurrency(audienceReach.moneySpent) },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const originalEntry = originalData.find((entry) => entry.name === payload[0].name);

      return (
        <div className="custom-tooltip" style={{ backgroundColor: "#fff", padding: "5px", border: "1px solid #ccc" }}>
          <p>{`${originalEntry.name}: ${originalEntry.value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <Content>
      <h5>Audience Reach</h5>
      <div className="wrap">
        <ResponsiveContainer width={180} height={250}>
          <PieChart>
            <Tooltip content={<CustomTooltip />} />
            <Pie
              data={data}
              innerRadius={40}
              outerRadius={80}
              fill={theme.chart[1]}
              paddingAngle={0}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <Footer>
          <p>
            <span style={{ color: theme.chart[1] }}>●</span> Conversion
          </p>
          <p>
            <span style={{ color: "#ADB537" }}>●</span> Clicks
          </p>
          <p>
            <span style={{ color: "#666B20" }}>●</span> Amount Spent
          </p>
        </Footer>
      </div>
    </Content>
  );
};

export default PieChartTab;
